module.exports = __webpack_public_path__ + "img/fa-cash-register.362b75d1.svg";